// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2ZnFL {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.buNYGZ {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  border-radius: var(--radius-s);
  border: 1px solid transparent;
  background-color: var(--surface-neutral-pale);
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;
}

.buNYGZ:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
}

.buNYGZ.LsIX1r {
  background-color: var(--surface-primary-subtle);
}

.buNYGZ:hover:not(.LsIX1r) {
  background-color: var(--surface-primary-subtle);
}

.vOIZ8X {
  display: flex;
  align-items: flex-start;
  padding: 2px;
}

.zNgWrj {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  flex: 1;
}

.bgF3cp {
  display: flex;
  flex-direction: column;
}

.cBW9Ge {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.XhiqyH {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.woFTCi {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.QZURMT {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-0-5);
}

.vyW44f {
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bLPXQD {
  width: 10px;
  height: 10px;
  filter: brightness(0) saturate(100%) invert(43%) sepia(96%) saturate(1352%) hue-rotate(360deg) brightness(102%)
    contrast(97%);
}

.V96YQB {
  font-family: var(--font-family-base);
  font-size: 10px;
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.UfolGz {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.uruOeq {
  width: 100%;
  height: 1px;
  background: var(--surface-neutral-soft);
}

.j5nOR8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-0-5);
}

.dKXdmd {
  font-family: var(--font-family-base);
  font-size: 10px;
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: #000000;
  margin: 0;
}

._4iXt1b {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1);
}

.rgTdL5 {
  font-weight: var(--font-weight-medium);
}

.n7ES0P {
  display: flex;
  height: var(--spacing-2);
  width: var(--spacing-2);
}

.Eg5Juf {
  position: absolute;
  right: 24px;
  top: 64px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/ProductFamilyOption/ProductFamilyOption.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,6CAA6C;EAC7C,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;iBACe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.card {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  border-radius: var(--radius-s);\n  border: 1px solid transparent;\n  background-color: var(--surface-neutral-pale);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  text-align: left;\n}\n\n.card:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n}\n\n.card.selected {\n  background-color: var(--surface-primary-subtle);\n}\n\n.card:hover:not(.selected) {\n  background-color: var(--surface-primary-subtle);\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: flex-start;\n  padding: 2px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  flex: 1;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.types {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.type {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-0-5);\n}\n\n.typeIcon {\n  width: 10px;\n  height: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.typeIconImage {\n  width: 10px;\n  height: 10px;\n  filter: brightness(0) saturate(100%) invert(43%) sepia(96%) saturate(1352%) hue-rotate(360deg) brightness(102%)\n    contrast(97%);\n}\n\n.typeLabel {\n  font-family: var(--font-family-base);\n  font-size: 10px;\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.patInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background: var(--surface-neutral-soft);\n}\n\n.patNumberSection {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-0-5);\n}\n\n.patNumberLabel {\n  font-family: var(--font-family-base);\n  font-size: 10px;\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: #000000;\n  margin: 0;\n}\n\n.patNumberContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.patNumber {\n  font-weight: var(--font-weight-medium);\n}\n\n.copyButton {\n  display: flex;\n  height: var(--spacing-2);\n  width: var(--spacing-2);\n}\n\n.alert {\n  position: absolute;\n  right: 24px;\n  top: 64px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `e2ZnFL`,
	"card": `buNYGZ`,
	"selected": `LsIX1r`,
	"checkboxContainer": `vOIZ8X`,
	"content": `zNgWrj`,
	"header": `bgF3cp`,
	"title": `cBW9Ge`,
	"description": `XhiqyH`,
	"types": `woFTCi`,
	"type": `QZURMT`,
	"typeIcon": `vyW44f`,
	"typeIconImage": `bLPXQD`,
	"typeLabel": `V96YQB`,
	"patInfo": `UfolGz`,
	"divider": `uruOeq`,
	"patNumberSection": `j5nOR8`,
	"patNumberLabel": `dKXdmd`,
	"patNumberContainer": `_4iXt1b`,
	"patNumber": `rgTdL5`,
	"copyButton": `n7ES0P`,
	"alert": `Eg5Juf`
};
module.exports = ___CSS_LOADER_EXPORT___;
